import Vue from 'vue';

export const appState = Vue.observable({
    pendingFileUploads: 0,
    debugFillInProgress: false,
});
